module.exports = __webpack_public_path__ + "img/d12.3d46fd55.png";